import 'owl.carousel';


(($) => {

    $(document).ready(() => {

        function handle_billing_postcode() {
            var inputPostcode = $('input[name=' + ix_postcode_config['billing_postcode'] + ']');
            var inputHousenr = $('input[name=' + ix_postcode_config['billing_housenr'] + ']');

            inputPostcode.change(billing_changed);
            inputHousenr.change(billing_changed);
        }

        function billing_changed() {
            var inputPostcode = $('input[name=' + ix_postcode_config['billing_postcode'] + ']');
            var inputHousenr = $('input[name=' + ix_postcode_config['billing_housenr'] + ']');

            lookupPostcode(inputPostcode.val(), inputHousenr.val(), function (response) {
                var inputCity = $('input[name=' + ix_postcode_config['billing_city'] + ']');
                var inputStreet = $('input[name=' + ix_postcode_config['billing_street'] + ']');
                if (response.found) {
                    inputCity.val(response.city);
                    inputStreet.val(response.street);
                } else {
                    inputCity.val('');
                    inputStreet.val('');
                }

                $(document).trigger('plugin:address-change', [inputPostcode, response]);
            });
        }


        function handle_shipping_postcode() {
            var inputPostcode = $('input[name=' + ix_postcode_config['shipping_postcode'] + ']');
            var inputHousenr = $('input[name=' + ix_postcode_config['shipping_housenr'] + ']');

            inputPostcode.change(shipping_changed());
            inputHousenr.change(shipping_changed());
        }

        function shipping_changed() {
            var inputPostcode = $('input[name=' + ix_postcode_config['shipping_postcode'] + ']');
            var inputHousenr = $('input[name=' + ix_postcode_config['shipping_housenr'] + ']');

            lookupPostcode(inputPostcode.val(), inputHousenr.val(), function (response) {
                var inputCity = $('input[name=' + ix_postcode_config['shipping_city'] + ']');
                var inputStreet = $('input[name=' + ix_postcode_config['shipping_street'] + ']');
                if (response.found) {
                    inputCity.val(response.city);
                    inputStreet.val(response.street);
                } else {
                    inputCity.val('');
                    inputStreet.val('');
                }


                $(document).trigger('plugin:address-change', [inputPostcode, response]);
            });
        }

        function lookupPostcode(postcode, housenr, callback) {
            if (!/[0-9]+\s?[a-z]{2}/i.test(postcode)) {
                return;
            }

            var request_data = {
                postcode: postcode,
                housenr: housenr
            };

            $.ajax({
                type: 'POST',
                url: ix_postcode_config['postcode_api_endpoint'],
                data: request_data,
                success: function (data, textStatus, xhr) {
                    data = $.extend(data, request_data);
                    callback(data);
                }
            });
        }

        if (typeof ix_postcode_config !== 'undefined') {

            if (ix_postcode_config['billing_postcode'] && ix_postcode_config['billing_housenr']
                && ix_postcode_config['billing_city'] && ix_postcode_config['billing_street']) {
                handle_billing_postcode();
            }


            if (ix_postcode_config['shipping_postcode'] && ix_postcode_config['shipping_housenr']
                && ix_postcode_config['shipping_city'] && ix_postcode_config['shipping_street']) {
                handle_shipping_postcode()
            }

        }

        $(document).on('click', '.address-manual-switch', function () {
            $('body').addClass('manual-address');
            return false;
        });

        $(document).on('input change', '[name="billing_postcode_clone"], [name="shipping_postcode_clone"]', function () {
            let name = $(this).attr('name').replace('_clone', '');
            $('[name="' + name + '"]').val($(this).val());
        });

        $(document).on('input change hover blur', '[name="billing_postcode"], [name="billing_address_1_housenr"], [name="shipping_postcode"], [name="shipping_address_1_housenr"]', function () {
            let name = $(this).attr('name') + '_clone';
            if (['billing_address_1_housenr', 'shipping_address_1_housenr'].indexOf($(this).attr('name')) >= 0) {
                name = $(this).attr('name').replace('address_1_housenr', 'housenr');
            }

            $('[name="' + name + '"]').val($(this).val());
        });

        $(document).on('input change hover blur', '[name="shipping_address_1_housenr"], [name="shipping_address_1_street"]', function () {
            if ($('[name="shipping_address_1"]').length) {
                $('[name="shipping_address_1"]').val($('[name="shipping_address_1_street"]').val() + ' ' + $('[name="shipping_address_1_housenr"]').val());
            }
        })

        if ($('[name="shipping_address_1"]').length && $('[name="shipping_address_1_street"]').length && $('[name="shipping_address_1_housenr"]').length) {
            $('[name="shipping_address_1"]').val($('[name="shipping_address_1_street"]').val() + ' ' + $('[name="shipping_address_1_housenr"]').val());
        }

        $(document).on('plugin:address-change', function (ev, target, data) {

            let container = $(target).closest('.form-row');
            let field = container.find('.address-manual-switch .address');
            if (!data.street || !data.housenr || !data.postcode || !data.city) {
                field.html('');
                if (data.housenr && data.postcode) {
                    $('body').addClass('manual-address');
                }

                return;
            }

            let address = data.street + ' ' + data.housenr + ', ' + data.postcode + ' ' + data.city;
            field.html(address);

            container.parent()
                .find("input[name$='_address_1_housenr']")
                .val(data.housenr);

            $('.address-manual-switch').trigger('click');
        });

        window.setTimeout(() => {
            $('select[name="billing_country"], select[name="shipping_country"]').trigger('change');
            $('[name="billing_postcode_clone"], [name="shipping_postcode_clone"]').each(function () {
                if ($(this).val()) {
                    $(this).trigger('change');
                }
            });
        }, 10);

        let configurator = $('.durasein-configurator');

        if (!configurator.length) {
            return;
        }

        let currentConfigurationId;
        let finalize = (configurationId, overview) => {
            $.ajax(scriptAjax.ajax_url, {
                method: 'POST',
                data: {action: 'duraseinConfig', nonce: scriptAjax.localact_nonce, configurationId, overview},
                success: function (data, textStatus, jqxhr) {
                    currentConfigurationId = configurationId;

                    configurator.addClass('checkout');
                    configurator.html(data);
                },
                complete: function (jqxhr, textStatus) {
                    configurator.removeClass('loading');

                    console.log(textStatus)

                    if (textStatus !== 'success') {
                        alert('Uw offerte kon niet verwerkt worden. Probeer het later nog eens.');
                    }
                }
            });
        };

        const API_URL = configurator.data('api-url');
        const TENANT_ID = configurator.data('tenant-id');
        const SHOWROOM_URL = configurator.find('iframe').attr('src').split('://')[1].split('elfsquad.io/')[0] + 'elfsquad.io';
        const ELF_ORG_ID = '76b0804e-0737-47bf-a588-7805a1e82de0';
        window.addEventListener('message', function (e) {
            try {
                let message = JSON.parse(e.data);
                if (message && message.action) {
                    if (message.action !== 'createQuotation') {
                        return;
                    }

                    let configurationId = message.argument;
                    configurator.addClass('loading');
                    fetch(`${API_URL}/3.0/configurator/${configurationId}/overview`, {
                        headers: {'x-elfskot-domain': SHOWROOM_URL}
                    }).then(async (response) => {
                        let overview = await response.json();
                        finalize(configurationId, overview);
                    }).catch(() => {
                        finalize(configurationId);
                    });
                }
            } catch (e) {
                console.error(e)
            }
        }, false);

        $('body').on('click', '.product-remove .remove', function () {
            location.reload();
        });

        $('body').on('change', '#ship-to-different-address-checkbox', function () {
            if (this.checked) {
                $('.shipping_address').show();
            } else {
                $('.shipping_address').hide();
            }
        });

        $('body').on('click', '.button.call-to-action', function () {
            let type = 'offer';
            if ($(this).is('.action-order')) {
                type = 'order';
            }

            configurator.addClass('loading');
            let data = $('#shipping-address-input').serialize() +
                '&action=duraseinConfigOrder' +
                '&type=' + type +
                '&nonce=' + scriptAjax.localact_nonce +
                '&configurationId=' + currentConfigurationId;
            $.ajax(scriptAjax.ajax_url, {
                method: 'POST',
                data: data,
                success: function (data, textStatus, jqxhr) {
                    if (type == 'order') {
                        location.href = configurator.data('thankyou-page-order');
                    } else {
                        location.href = configurator.data('thankyou-page');
                    }
                },
                complete: function (jqxhr, textStatus) {

                    console.log(textStatus)

                    configurator.removeClass('loading');
                    console.log(textStatus, jqxhr);
                    if (textStatus !== 'success') {
                        alert('Uw offerte kon niet verwerkt worden. Probeer het later nog eens.');
                    }
                }
            });
        });
    });


})(jQuery);

document.addEventListener('DOMContentLoaded', () => {

    jQuery(".js-add-to-wishlist").click(function () {

        let button = jQuery(this);

        console.log(button)

        button.addClass('is-loading');
        const btnA = button.find('a')

        console.log(btnA)

        if (button.hasClass('is-favorite')) {

            jQuery.post(btnA.attr('href'), {
                'tinvwl-product_id': btnA.data('wishlist-pid'),
                'tinvwl-action': 'remove',
                'tinvwl-security': btnA.data('nonce'),
                'tinvwl-paged': 1,
                'tinvwl-sharekey': btnA.data('share-key')
            }, function (data) {
                btnA.attr('href', window.location.href.split('?')[0] + '?add_to_wishlist=' + button.data('product-id'));
                button.find('span').text('Voeg toe aan favorieten')
                button.removeClass('is-loading');
                button.removeClass('is-favorite');
            });
        } else {
            jQuery.post(btnA.attr('href'), {
                tinv_wishlist_id: '',
                tinv_wishlist_name: '',
                product_type: btnA.data('product-type'),
                product_id: btnA.data('product-id'),
                product_variation: '0',
                product_action: 'addto'
            }, function (data) {
                btnA.data('wishlist-pid', data.wishlist_pid);
                btnA.data('nonce', data.wishlist_nonce);
                btnA.data('share-key', data.wishlist_url.replace(/^.*\/([A-Za-z0-9]+)\/$/, '$1'));
                button.find('span').text('Verwijder uit favorieten')
                btnA.attr('href', '/?wc-ajax=tinvwl');
                button.removeClass('is-loading');
                button.addClass('is-favorite');

            });
        }

        return false;
    })

    jQuery('#account_email').attr('readonly', 'readonly');

    jQuery('.owl-carousel').each(function () {


        var loop = true;
        if (jQuery(this).data('min-item-count')) {
            let items = jQuery(this).find('.item');
            for (let i = jQuery(this).find('.item').length, limit = parseInt($(this).data('min-item-count')); i < limit; i++) {
                items.first().clone().appendTo(items.first().parent());
            }

            if (loop == false) {
                jQuery(this).closest('.media-carousel')
                    .addClass('media-carousel-no-nav');
            }
        }

        if (jQuery(this).is('.owl-small-only') && !screen.is(screen.size.S)) {
            jQuery(this).removeClass('owl-carousel');
            return;
        }

        if (jQuery(this).is('.owl-med-down') && !screen.is(screen.size.S) && !screen.is(screen.size.M)) {
            jQuery(this).removeClass('owl-carousel');
            return;
        }

        jQuery(this).parent().find('.prev').click(() => {
            jQuery(this).trigger('prev.owl.carousel');
            return false;
        });

        jQuery(this).parent().find('.next').click(() => {
            jQuery(this).trigger('next.owl.carousel');
            return false;
        });

        jQuery(this).find('.item-title').remove();
        let properties = {
            loop: loop,
            nav: false,
            margin: (jQuery('body').is('.single-product') ? 30 : 0),
            responsive: {},
        };

        if (jQuery(this).data('item-count')) {
            properties.items = jQuery(this).data('item-count');
        }

        if (jQuery(this).data('xs-item-count')) {
            properties.responsive[screen.size.S] = {
                items: jQuery(this).data('xs-item-count')
            };

            if (jQuery(this).data('s-item-count')) {
                properties.responsive[400] = {
                    items: jQuery(this).data('s-item-count')
                };
            }
        } else {
            if (jQuery(this).data('s-item-count')) {
                properties.responsive[screen.size.S] = {
                    items: jQuery(this).data('s-item-count')
                };
            }
        }

        if (jQuery(this).data('m-item-count')) {
            properties.responsive[screen.size.M] = {
                items: jQuery(this).data('m-item-count')
            };
        }

        if (jQuery(this).data('item-centered')) {
            properties.center = true;
        }

        if (jQuery(this).data('auto-width')) {
            properties.autoWidth = true;
        }

        if (jQuery(this).data('autoplay')) {
            properties.autoplay = true;
        }

        if (jQuery(this).data('delay')) {
            properties.autoplayTimeout = 5000;
        }

        if (jQuery(this).data('loop')) {
            properties.loop = true;
        }

        jQuery(this).owlCarousel(properties);
        window.setTimeout(() => {
            jQuery(this).trigger("refresh.owl.carousel");
        }, 4000);
    });

})

